var Swatch = Backbone.Model.extend({
    defaults: {
        'post_id': 0,
        'type' : null,
        'name' : '',
        'code' : '',
        'image' : ''
    }
});
export {Swatch};